(function () {
  'use strict';

  // =================================================================
  // CONFIGURACIÓN — sustituir por los endpoints reales cuando el
  // backend esté desplegado. Recomendado: exponerlos vía App Proxy
  // de Shopify (rutas /apps/...) para evitar problemas de CORS al
  // llamarlos desde el navegador del cliente.
  // =================================================================
  var MEMBER_STATUS_ENDPOINT = '/apps/izas-members/member-status'; // conectado
  var SUBMIT_SURVEY_ENDPOINT = '/apps/izas-members/submit-survey'; // conectado

  var root = document.querySelector('.izas-survey');
  if (!root) return;

  function $(id) { return document.getElementById(id); }

  // --- Intereses: vienen del schema del section (editable sin tocar código) ---
  var interestsDataEl = $('izas-survey-interests-data');
  var INTERESES = [];
  try {
    INTERESES = JSON.parse(interestsDataEl ? interestsDataEl.textContent : '[]');
  } catch (e) {
    INTERESES = [];
  }

  // --- Comprobación de member: consulta el tag de tier en Shopify ---
  function checkMemberStatus(email) {
    return fetch(MEMBER_STATUS_ENDPOINT + '?email=' + encodeURIComponent(email))
      .then(function (res) {
        if (!res.ok) throw new Error('member-status: ' + res.status);
        return res.json();
      });
  }

  // --- Envío de la encuesta: escribe el metafield en Shopify y envía el evento a Connectif ---
  function submitSurvey(payload) {
    return fetch(SUBMIT_SURVEY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('submit-survey: ' + res.status);
      return res.json().catch(function () { return {}; });
    });
  }

  function renderPills(container) {
    if (!container) return;
    container.innerHTML = '';
    INTERESES.forEach(function (label) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pill';
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = label;
      btn.addEventListener('click', function () {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!pressed));
      });
      container.appendChild(btn);
    });
  }
  renderPills($('izas-survey-pills-member'));
  renderPills($('izas-survey-pills-guest'));

  function getSelected(container) {
    if (!container) return [];
    return Array.prototype.slice
      .call(container.querySelectorAll('.pill[aria-pressed="true"]'))
      .map(function (b) { return b.textContent; });
  }

  var views = {
    email: $('izas-survey-view-email'),
    member: $('izas-survey-view-member'),
    guest: $('izas-survey-view-guest'),
    thanks: $('izas-survey-view-thanks'),
  };
  function showView(name) {
    Object.keys(views).forEach(function (k) {
      if (views[k]) views[k].classList.remove('active');
    });
    if (views[name]) views[name].classList.add('active');
  }
  function setProgress(step) {
    var els = root.querySelectorAll('.progress i');
    els.forEach(function (el) {
      el.classList.toggle('on', Number(el.dataset.step) <= step);
    });
  }

  var currentEmail = '';

  // --- Paso 1: email ---
  var formEmail = $('izas-survey-form-email');
  var emailInput = $('izas-survey-email');
  var emailError = $('izas-survey-email-error');
  var btnEmail = $('izas-survey-btn-email');

  if (formEmail) {
    formEmail.addEventListener('submit', function (e) {
      e.preventDefault();
      emailError.textContent = '';
      var email = emailInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailError.textContent = 'Introduce un email válido.';
        return;
      }
      currentEmail = email;
      btnEmail.disabled = true;
      btnEmail.classList.add('loading');
      checkMemberStatus(email)
        .then(function (result) {
          setProgress(2);
          showSessionNotice(email, result);
          showView(result.isMember ? 'member' : 'guest');
        })
        .catch(function () {
          emailError.textContent = 'No hemos podido comprobar tu cuenta. Inténtalo de nuevo.';
        })
        .finally(function () {
          btnEmail.disabled = false;
          btnEmail.classList.remove('loading');
        });
    });
  }

  // Si hay sesión iniciada y el email real de la cuenta no coincide con lo
  // que se ha escrito a mano, avisar: las respuestas se guardan siempre con
  // la cuenta de la sesión, nunca con el texto del campo.
  function showSessionNotice(typedEmail, result) {
    root.querySelectorAll('.session-notice').forEach(function (el) { el.remove(); });
    if (!result.viaSession || !result.email) return;
    if (result.email.toLowerCase() === typedEmail.toLowerCase()) return;

    var target = result.isMember ? views.member : views.guest;
    if (!target) return;

    var notice = document.createElement('div');
    notice.className = 'session-notice';
    notice.textContent = 'Has iniciado sesión como ' + result.email + ' — tus respuestas se van a guardar con esa cuenta, no con ' + typedEmail + '.';
    target.insertBefore(notice, target.firstChild);
  }

  // --- Paso 2: miembro / invitado ---
  function wireSurveyForm(formId, btnId, pillsId, isMember) {
    var form = $(formId);
    var btn = $(btnId);
    var pillsEl = $(pillsId);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      btn.classList.add('loading');
      var payload = {
        email: currentEmail,
        isMember: isMember,
        intereses: getSelected(pillsEl),
      };
      submitSurvey(payload).then(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        var thanksCopy = $('izas-survey-thanks-copy');
        if (thanksCopy) {
          thanksCopy.textContent = isMember
            ? 'Ya tenemos tus intereses guardados. Iremos afinando lo que te mostramos a partir de aquí.'
            : 'Ya tenemos tus intereses guardados. Si te unes al club, tu nivel se calculará solo con tus compras.';
        }
        showView('thanks');
      });
    });
  }
  wireSurveyForm('izas-survey-form-member', 'izas-survey-btn-member', 'izas-survey-pills-member', true);
  wireSurveyForm('izas-survey-form-guest', 'izas-survey-btn-guest', 'izas-survey-pills-guest', false);

  // ---------------------------------------------------------------
  // Si el visitante abre "Crear cuenta" en una pestaña nueva desde
  // la vista de invitado, al volver a esta pestaña comprobamos otra
  // vez si ya es member. Si lo es, pasamos a la vista de member sin
  // que tenga que hacer nada, y trasladamos los intereses que ya
  // había marcado para que no los pierda.
  // ---------------------------------------------------------------
  function transferSelections(fromEl, toEl) {
    if (!fromEl || !toEl) return;
    var fromPills = fromEl.querySelectorAll('.pill');
    var toPills = toEl.querySelectorAll('.pill');
    fromPills.forEach(function (p, i) {
      if (toPills[i]) toPills[i].setAttribute('aria-pressed', p.getAttribute('aria-pressed'));
    });
  }

  function maybeUpgradeToMember() {
    if (!views.guest || !views.guest.classList.contains('active')) return;
    if (!currentEmail) return;
    checkMemberStatus(currentEmail).then(function (result) {
      if (result.isMember) {
        transferSelections($('izas-survey-pills-guest'), $('izas-survey-pills-member'));
        setProgress(2);
        showView('member');
      }
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') maybeUpgradeToMember();
  });
  window.addEventListener('focus', maybeUpgradeToMember);

})();